import { defineMessages } from 'react-intl';

export default defineMessages({
    January: {
        id: 'components.common.dataPicker.fullMonths.Jan',
        defaultMessage: 'January'
    },
    February: {
        id: 'components.common.dataPicker.fullMonths.Feb',
        defaultMessage: 'February'
    },
    March: {
        id: 'components.common.dataPicker.fullMonths.Mar',
        defaultMessage: 'March'
    },
    April: {
        id: 'components.common.dataPicker.fullMonths.Apr',
        defaultMessage: 'April'
    },
    May: {
        id: 'components.common.dataPicker.fullMonths.May',
        defaultMessage: 'May'
    },
    June: {
        id: 'components.common.dataPicker.fullMonths.Jun',
        defaultMessage: 'June'
    },
    July: {
        id: 'components.common.dataPicker.fullMonths.July',
        defaultMessage: 'July'
    },
    August: {
        id: 'components.common.dataPicker.fullMonths.Aug',
        defaultMessage: 'August'
    },
    September: {
        id: 'components.common.dataPicker.fullMonths.Sep',
        defaultMessage: 'September'
    },
    October: {
        id: 'components.common.dataPicker.fullMonths.Oct',
        defaultMessage: 'October'
    },
    November: {
        id: 'components.common.dataPicker.fullMonths.Nov',
        defaultMessage: 'November'
    },
    December: {
        id: 'components.common.dataPicker.fullMonths.Dec',
        defaultMessage: 'December'
    }
});
